import React from 'react';
import { Box, Chip, Dialog, Grid, IconButton, InputAdornment, Typography, } from '@mui/material';
import Save from '@mui/icons-material/Save';
import styles from '../../../../../../../custom/style.module.css';
import {
  CustomDialogContent,
  CustomDialogTitle,
  CustomInputLabel,
  CustomTextField,
  InputProps,
  StyledCard,
} from '../../../../../../../custom/components';
import { CloseIconBtn, } from '../../../../../../../custom/constants';

const BounceModal = (props) => {
  const bounceEmails = (props.bounceList || '')
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal == 'bounce'} onClose={props.onClose} maxWidth={'md'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Notify Mail Bounce
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form onSubmit={props.saveMailBounce} onReset={props.onClose} className={styles.w100}>
          <CustomDialogContent>

            <Typography variant='body2' color='primary' mb={2} borderBottom={'1px solid #e8e8e8'}>
              Add one or more email addresses (separate multiple email addresses with commas).
            </Typography>

            <StyledCard>
              <Grid container spacing={2} className={styles.formGrid}>
                <Grid item xs={12} sm={12}>
                  <CustomInputLabel htmlFor='Mails' required>Mails</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='bounce'
                    placeholder='Type email and press Enter'
                    type='text'
                    onChange={props.onChangeBounce}
                    name='bounce'
                    value={props.bounce}
                    error={Boolean(props.bounceErrors?.bounce)}
                    helperText={props.bounceErrors?.bounce}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton aria-label='save new file name'
                            disabled={!props.bounce}
                            onClick={props.saveMailBounce}
                            color='primary'
                            size='small'
                          >
                            <Save color='inherit' fontSize='inherit' />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                        
                  />
                </Grid>
                {!!bounceEmails.length && (
                  <Grid item xs={12} sm={12}>
                    <Box sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1,
                    }}>
                      {bounceEmails.map((email) => (
                        <Chip
                          key={email}
                          label={email}
                          color='primary'
                          variant='outlined'
                          className={styles.mailChip}
                          onDelete={() => props.onDeleteBounceEmail(email)}
                        />
                      ))}
                    </Box>
                  </Grid>
                )}
              </Grid>
            </StyledCard>
          </CustomDialogContent>
        </form>
      </Dialog>
    </div>
  );
};
export default BounceModal;